/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { AuxliaryOutputsNames } from 'web-usb-module';

/**
 * The four auxiliary relay outputs a position can drive from ACD agent status, typically wired to a desk
 * status light pole, as an ordered list: auxiliary output *n* is at index *n - 1*.
 *
 * A position drives these through whichever hardware it has fitted: the CC-Hub's on-board relays, or an
 * external Sealevel SeaDAC Lite module on RTI positions that have no relay outputs of their own. Both
 * address the relays with these identifiers and share a single mapping of relay to agent status, so the
 * behaviour is identical whichever is present.
 *
 * The identifiers themselves come from the vendored CC-Hub driver for historical reasons, and are the
 * platform's definition of these outputs. The ordering is what the SeaDAC driver needs to turn a relay
 * into a bit position, and is not available from the vendored enum, which also covers eight unrelated
 * outputs. `AuxiliaryOutput` in the `ccHub` feature is an alias of `AuxRelay`.
 */
export const AUX_RELAYS = [
    AuxliaryOutputsNames.Auxiliary_output_1,
    AuxliaryOutputsNames.Auxiliary_output_2,
    AuxliaryOutputsNames.Auxiliary_output_3,
    AuxliaryOutputsNames.Auxiliary_output_4
] as const;

export type AuxRelay = (typeof AUX_RELAYS)[number];
